var map = {
	"./bug.svg": 86639,
	"./confusion.svg": 85490,
	"./conversion.svg": 93690,
	"./frustration.svg": 42242,
	"./issue.svg": 31962,
	"./success.svg": 98037
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45205;
module.exports = webpackAsyncContext;